import React, { useMemo } from 'react';
import classNames from 'classnames';

export interface TimePickerUnitProps {
  label: string;
  value: number;
  handleClick: (value: number) => void;
  selected: boolean;
}

function TimePickerUnit(props: TimePickerUnitProps) {
  const { label, value, handleClick, selected } = props;

  const className = useMemo(
    () =>
      classNames('ui-time-picker-unit', {
        'ui-time-picker-unit-selected': selected,
      }),
    [selected]
  );

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <li
      className={className}
      role="option"
      aria-selected={selected ? 'true' : undefined}
      tabIndex={-1}
      onClick={() => handleClick(value)}
    >
      {label}
    </li>
  );
}

export default TimePickerUnit;
